
// import bannerVideo  from "/videos/bannerVideo.mp4"
export default function NavbarVideo() {
  return (
    <>
    <div className="conitainer">
      
    <div className="video-container video-brand">
    <video autoPlay loop muted playsInline className="background-video">
        {/* <source src="https://vhotelthegrandshoba.com/videos/bannerVideo.mp4" type="video/mp4"/> */}
        <source src="/videos/hShoba.webm" type="video/mp4"/>
        Your browser does not support the video tag.
    </video>
 
    </div>
    </div>
    
    </>
  )
}
